
import createIcon from "./createIcon";

export const AlertCircleIcon = createIcon('AlertCircle', (props) => {
  return (
    <svg {...props} viewBox="0 0 57 57">
      <g>
        <path d="M-0.156738 28.5C-0.156738 44.239 12.6042 57 28.3433 57C44.0823 57 56.8433 44.239 56.8433 28.5C56.8433 12.761 44.0823 0 28.3433 0C12.6042 0 -0.156738 12.761 -0.156738 28.5ZM25.5 14.7859C25.5 13.1292 26.8433 11.7859 28.5 11.7859C30.1567 11.7859 31.5 13.1292 31.5 14.7859L31.5 32.6431C31.5 34.2998 30.1567 35.6431 28.5 35.6431C26.8433 35.6431 25.5 34.2998 25.5 32.6431L25.5 14.7859ZM28.5 38.7144C30.4331 38.7144 32 40.2812 32 42.2139C32 44.147 30.4331 45.7144 28.5 45.7144C26.5669 45.7144 25 44.147 25 42.2144C25 40.2812 26.5669 38.7144 28.5 38.7144Z" clipRule="evenodd" fill={props.color} fillOpacity="1" fillRule="evenodd" />
      </g>
    </svg >
  )
});
